import { Route, Routes } from "react-router-dom";

import {
  ActivationRequiredWarning,
  PageBanner,
  QuickTable,
  QuickTableFilterTabs,
} from "../../components";
import { CreateEditPaymentLinkForm } from "./CreateEditPaymentLinkForm/CreateEditPaymentLinkForm";
import { paymentLinksDisplayFormatter } from "./paymentLinksDisplayFormatter";
import { IPaymentLinkViewProps } from "./PaymentLinks";
import { PaymentLinksDetailsModal } from "./PaymentLinksDetailsModal/PaymentLinksDetailsModal";

import linkColoredIcon from "../../assets/icons/link-colored.svg";

export const View = (props: IPaymentLinkViewProps) => {
  return (
    <>
      <PageBanner
        iconSource={linkColoredIcon}
        pageTitle={"Payment Links"}
        pageSubtitle={"Receive payments with your payment links"}
        pageDescription={
          "Get started quickly, send payment links to your customers, monitor and receive payments securely."
        }
        linkTitle={"Create your payment link"}
        linkSubtitle={"Create a custom payment page and share a link to it.."}
        linkButtonText={"Create payment link"}
        linkButtonUrl={"create"}
        linkButtonAction={props.openCreateNewModal}
      />

      <ActivationRequiredWarning
        title="To create a payment link, you need to activate your profile"
        subtitle="Our guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <QuickTable
        id="paymentLinksTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.link_url_with_hostname}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={paymentLinksDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
        createNewButtonText="New Payment Link"
        disableClickOnColumns={["link_url"]}
        openDetailsModal={props.openDetailsModal}
      />

      <Routes>
        <Route
          path="create"
          element={
            <CreateEditPaymentLinkForm
              refreshTable={props.refreshTable}
              goBackOnClose={false}
            />
          }
        />
        <Route
          path=":id/edit"
          element={
            <CreateEditPaymentLinkForm
              refreshTable={props.refreshTable}
              goBackOnClose={true}
            />
          }
        />
        <Route path=":id/details" element={<PaymentLinksDetailsModal />} />
      </Routes>
    </>
  );
};
